"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var ProgressGroup = __importStar(require("./O_ProgressGroup"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var material_1 = require("@mui/material");
var Img = (0, material_1.styled)('img')(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
/** Display progress along with a logo */
var Component = function (p) { return (Preact.h(ProgressGroup.Component, { statusText: p.statusText },
    Preact.h(Box_1.default, { paddingBottom: "68px", sx: { display: 'flex', justifyContent: 'center' } },
        Preact.h(Img, { sx: { width: 'auto', height: { xs: '68px', sm: '85px' }, maxWidth: '260px' }, src: p.imageUrl })))); };
exports.Component = Component;
exports.Component.displayName = 'ProgressGroupWithLogo';
var templateObject_1;
